var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.1,184.8c0-6.9-2.7-13.5-7.6-18.4c-9.8-9.8-26.9-9.8-36.8,0L339.9,302.1L204.2,166.4c-9.8-9.8-26.9-9.8-36.8,0 c-4.9,4.9-7.6,11.4-7.6,18.4c0,6.9,2.7,13.5,7.6,18.4l135.7,135.7L167.4,474.6c-10.1,10.1-10.1,26.6,0,36.8 c4.9,4.9,11.4,7.6,18.4,7.6c7,0,13.5-2.7,18.4-7.6l135.7-135.7l135.7,135.7c9.8,9.8,27,9.8,36.8,0c4.9-4.9,7.6-11.5,7.6-18.4 c0-7-2.7-13.5-7.6-18.4L376.7,338.9l135.7-135.7C517.4,198.2,520.1,191.7,520.1,184.8L520.1,184.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b9d57d11dd16f641bfff632276dd9399.svg";
export { ForwardRef as ReactComponent };